export default __webpack_public_path__ + "static/media/team-skillset-icon.a36cc7df.svg";